export enum CheckoutType {
    POPUP = "popup",
    EMBEDDED = "embedded",
    URL = "url",
}

export enum PopupCheckoutType {
    DEFAULT = "default",
    CUSTOM = "custom",
}

export enum EmbeddedTheme {
    DARK = "dark",
    LIGHT = "light",
    AUTO = "auto",
}
